import React, { Component } from 'react';
import { Form, Col } from 'react-bootstrap';

import './CategoryAdd.css';

class CategoryAdd extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            colour: '',
            x: '0.0',
            y: '0.0',
            z: '0.0',
            azimuth: '0.0',
            errMsg: ''
        };
    }

    GetTitle = () => {
        return this.state.title
    }

    GetColour = () => {
        return this.state.colour
    }

    GetX = () => {
        return this.state.x
    }

    GetY = () => {
        return this.state.y
    }

    GetZ = () => {
        return this.state.z
    }

    GetAzimuth = () => {
        return this.state.azimuth
    }

    GetError = () => {
        return this.state.error
    }

    handleTitleChange = (e) => {
        this.setState({
            title: e.target.value,
            errMsg: ''
        });
    }

    handleColourChange = (e) => {
        this.setState({
            colour: e.target.value,
            errMsg: ''
        });
    }

    //colours are stored as 6 hex digits without '#' (matching the list swatch rendering);
    //the native picker works in '#rrggbb', so convert in both directions
    handlePickColour = (e) => {
        this.setState({
            colour: e.target.value.replace('#', ''),
            errMsg: ''
        });
    }

    pickerColour = () => {
        return /^[0-9a-fA-F]{6}$/.test(this.state.colour) ? '#' + this.state.colour : '#000000';
    }

    handleXChange = (e) => {
        this.setState({
            x: e.target.value,
            errMsg: ''
        });
    }

    handleYChange = (e) => {
        this.setState({
            y: e.target.value,
            errMsg: ''
        });
    }

    handleZChange = (e) => {
        this.setState({
            z: e.target.value,
            errMsg: ''
        });
    }

    handleAzimuthChange = (e) => {
        this.setState({
            azimuth: e.target.value,
            errMsg: ''
        });
    }

    //x/y/z only apply to muster points, so the row renders only when the parent asks for it
    renderCoordinates = () => {
        if (!this.props.showCoordinates)
            return null;

        return (
            <Form.Row>
                <Form.Group as={Col} controlId="frmX">
                    <Form.Label class="CategoryAddLabel">X</Form.Label>
                    <Form.Control className="CategoryAddControl" type="number" step="any" value={this.state.x} onChange={this.handleXChange}/>
                </Form.Group>

                <Form.Group as={Col} controlId="frmY">
                    <Form.Label class="CategoryAddLabel">Y</Form.Label>
                    <Form.Control className="CategoryAddControl" type="number" step="any" value={this.state.y} onChange={this.handleYChange}/>
                </Form.Group>

                <Form.Group as={Col} controlId="frmZ">
                    <Form.Label class="CategoryAddLabel">Z</Form.Label>
                    <Form.Control className="CategoryAddControl" type="number" step="any" value={this.state.z} onChange={this.handleZChange}/>
                </Form.Group>

                <Form.Group as={Col} controlId="frmAzimuth">
                    <Form.Label class="CategoryAddLabel">Azimuth</Form.Label>
                    <Form.Control className="CategoryAddControl" type="number" step="any" value={this.state.azimuth} onChange={this.handleAzimuthChange}/>
                </Form.Group>
            </Form.Row>
        )
    }

    render() {
        return (
            <div>
                <Form className="CategoryAddForm" onSubmit={this.handleSubmit}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="frmTitle">
                            <Form.Label class="CategoryAddLabel">Title</Form.Label>
                            <Form.Control className="CategoryAddControl" type="text" placeholder="Category Title" value={this.state.title} onChange={this.handleTitleChange}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="frmColour">
                            <Form.Label class="CategoryAddLabel">Colour</Form.Label>
                            <div style={{ display: 'flex' }}>
                                <Form.Control className="CategoryAddControl" type="text" placeholder="Category Colour" value={this.state.colour} onChange={this.handleColourChange} />
                                <input
                                    type="color"
                                    title="Pick a colour"
                                    value={this.pickerColour()}
                                    onChange={this.handlePickColour}
                                    style={{ width: '3rem', marginLeft: '0.5rem', padding: '0', border: '1px solid #282c34', borderRadius: '0.25rem', cursor: 'pointer', alignSelf: 'stretch' }}
                                />
                            </div>
                        </Form.Group>
                    </Form.Row>

                    { this.renderCoordinates() }
                </Form>
            </div>
        )
    }
}

export default CategoryAdd;
